<template>
	<div>
		<div class="row justify-content-center">
			<div class="col-12 col-ms-12 col-md-12 col-lg-12">
				<h5 v-if="ctaporpagar.Estatus == 'NO'">
					¿Desea confirmar como Pagado?
				</h5>
				<div class="form-group row">
					<div class="col-lg-6">
						<label for="">Fecha</label>
						<v-date-picker
							:masks="{input:'DD-MM-YYYY'}"
							v-model="ctaporpagar.FechaRealPago"
							:popover="{
								placement: 'bottom',
								visibility: 'click'
							}"
							:input-props="{
								class: 'col-md-6 form-control  calendar',
								style: 'cursor:pointer;background-color:#F9F9F9'
							}"
						/>
					</div>
					<div class="col-lg-6">
						<label for="">Comprobante</label>
						<div class="custom-file-input-image">
							<input
								@change="SubirComprobante()"
								type="file"
								ref="comprobante"
								name="comprobante"
								accept="application/pdf"
								class="custom-file-input"
								id="validateComprobante"
							/>
							<input type="text" v-model="Comprobante" class="form-control" />
							<button type="button" class="">
								<i class="fas fa-paperclip"></i>
							</button>
						</div>
					</div>
				</div>
				<div class="form-group row mt-3">
					<div class="col-lg-12">
						<label for="">Observaciones</label>
						<textarea
							v-model="ctaporpagar.Observacion"
							v-if="ctaporpagar.Estatus == 'NO'"
							placeholder=" Coloque sus observaciones"
							class="form-control"
							cols="2"
							rows="3"
						></textarea>
						<textarea
							v-model="ctaporpagar.Observacion"
							v-if="ctaporpagar.Estatus == 'SI'"
							readonly
							placeholder=" Coloque sus observaciones"
							class="form-control"
							cols="2"
							rows="3"
						></textarea>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "cuentasporpagaropera",
	props: ["poBtnSave"],
	data() {
		return {
			ctaporpagar: {
				IdCtaPagar: 0,
				Observacion: "",
				Estatus: "",
				FechaRealPago: null,
				Comprobante:''
			},
			date: "",
			Comprobante:''
		};
	},
	methods: {
		Pay() {
			let formData=new FormData();
			formData.set('FechaRealPago',this.ctaporpagar.FechaRealPago.toISOString());
			formData.set('Observacion',this.ctaporpagar.Observacion);
			formData.set('IdCtaPagar',this.ctaporpagar.IdCtaPagar);
			formData.set("Factura", this.ctaporpagar.Comprobante);
			let file = this.$refs.comprobante.files[0];
			formData.append("File", file);
			this.$http
				.post("ctaporpagar/changeestatus", formData,{
					headers:{
                    	'Content-Type':'multipart/form-data'
                	}
				})
				.then(res => {
					$("#Observacion").modal("hide");
					this.bus.$emit("List");
					this.$toast.success("Información Actualizada");
					this.Limpiar();
				})
				.catch(err => {
					this.$toast.error("La infromación no pudo actualizarse");
				});
		},
		getObservation() {
			this.$http
				.get("ctaporpagar/recovery", {
					params: { IdCtaPagar: this.ctaporpagar.IdCtaPagar }
				})
				.then(res => {
					const objCta = res.data.data.ctaporpagar;

					this.ctaporpagar = objCta;
					if (objCta.Comprobante==null) {
						this.Comprobante="Elegir Archivo (1MB)";	
					}
					else{
						this.Comprobante=objCta.Comprobante;
					}
					if (objCta.FechaRealPago == null) {
						this.ctaporpagar.FechaRealPago = new Date();
					} else {
						var uno = objCta.FechaRealPago.replace(/-/g, "\/");
						this.ctaporpagar.FechaRealPago = new Date(uno);

						// if (this.ctaporpagar.Estatus == "SI") {
						// 	this.bus.$off("Save");
						// }
					}
					
				});
		},
		Limpiar() {
			this.ctaporpagar = {
				IdCtaPagar: 0,
				Observacion: "",
				Estatus: "",
				Comprobante:""
			};
			this.Comprobante='Elegir Archivo (1MB)';
			this.date = "";
		},
		SubirComprobante(){
			const image = this.$refs.comprobante.files[0];
			var FileSize = image.size / 1024 / 1024; // in MB
			if (FileSize > 1) {
				this.$toast.info("Solo se puede subir archivos menores a 1 MB");
				const input = this.$refs.comprobante;
				input.type = "text";
				input.type = "file";
				return false;
			}
			var allowedExtensions = /(\.pdf|\.PDF)$/i;
			if (!allowedExtensions.exec(image.name)) {
				this.$toast.info("Extenciones permitidas .pdf");
				const input = this.$refs.comprobante;
				input.type = "text";
				input.type = "file";
				this.Comprobante = "Elegir archivo (1 MB)";
				return false;
			}
			this.Comprobante = image.name;
		}
	},

	created() {
		this.bus.$off("UploadO");
		this.bus.$on("UploadO", id => {
			this.ctaporpagar.IdCtaPagar = id;

			this.bus.$off("Save");
			this.bus.$on("Save", () => {
				this.Pay();
			});

			if (id > 0) {
				this.getObservation();
			}

			this.bus.$emit("Desbloqueo", false);
		});
	}
};
</script>
